module.exports = __webpack_public_path__ + "img/pass-logo.b9956aba.jpg";